import { render, staticRenderFns } from "./EventDate.vue?vue&type=template&id=78731ece&lang=pug&"
import script from "./EventDate.vue?vue&type=script&lang=js&"
export * from "./EventDate.vue?vue&type=script&lang=js&"
import style0 from "./EventDate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports